var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.21784 0C0.546201 0 0 0.598 0 1.33333V10.6667C0 11.402 0.546201 12 1.21784 12H9.74272C10.4144 12 10.9606 11.402 10.9606 10.6667V4.16146L9.74272 5.49479L9.74391 10.6667H1.21784V1.33333H8.3774L9.59524 0H1.21784ZM11.1389 0.195312L4.87136 7.05729L2.8662 4.86198L2.00515 5.80469L4.87136 8.94271L12 1.13802L11.1389 0.195312Z",
    fill: "#008CD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.30b5ba65f404e2397eee5c806fee269c.svg";
export { ForwardRef as ReactComponent };